import './style/style.scss';
import axios from 'axios';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './home';
import Notification from './components/notification';
import Introduction from './components/introduction';
import DirectPages from './components/notification/directpages';
import UnderConstruction from './components/notification/underconstruction';

// Global handler for rate-limit (HTTP 429) responses (VAPT #8/#10 CWE-770):
// surface the backend's message (e.g. "Too many delete requests...") so the
// existing toastError(error.message) calls show it instead of the generic
// "Request failed with status code 429".
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 429) {
      const data = error.response.data || {};
      error.message = data.error || data.message || 'Too many requests. Please slow down and try again.';
    }
    return Promise.reject(error);
  }
);

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/introduction" element={<Introduction />} />
          <Route path="/editor" element={<Home />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/underconstruction" element={<UnderConstruction />} />
          <Route path="*" element={<DirectPages />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
